export default "__VITE_ASSET__u$F93Cxh__"